/**
 * THE HELP SURFACES AND LANGUAGES — plan-019 DOM (design §31.5, §31.8.8; ADR 0065, proposed; glossary §6.33).
 *
 * The help widget is mounted on two surfaces — wetalk.io (`public_site`) and the customer portal (`portal`) — and speaks
 * two languages. A page in any other language shows no widget (plan-019 §7, review row); there is no fallback language.
 *
 * Imports nothing: the widget's launcher chunk and the protocol guards (`./protocol.ts`) read these lists.
 */
/** Where the help widget runs. `help_request.surface` and `help_conversation.surface` CHECK the same set (0153, 0154). */
export const HELP_SURFACE = ["public_site", "portal"];
/** The languages of the help assistant (FR-HA-2). `language_code` CHECKs the same set. */
export const HELP_LANGUAGE = ["en", "el"];
export function isHelpSurface(value) {
    return value === "public_site" || value === "portal";
}
export function isHelpLanguage(value) {
    return value === "en" || value === "el";
}
//# sourceMappingURL=surface.js.map